<div class="login-component" fxLayout="column">
    <div class="container">
        <firebase-ui (signInSuccessWithAuthResult)="authService.successCallback($event)">
        </firebase-ui>
    </div>
</div>